/**
 * useGuardedAction — gating PROATIVO: envolve uma ação de "criar X"; se o usuário
 * já está no limite, abre o UpgradeSheet em vez de executar. O backend continua
 * sendo a última palavra (interceptor 402); isto só melhora a UX evitando o erro.
 *
 * Uso:
 *   const guard = useGuardedAction('appointments_future');
 *   <Button onClick={() => guard(openNewAppointmentDialog)}>Novo agendamento</Button>
 */
import { useCallback } from 'react';
import { useLimit } from './useEntitlements';
import { useUpgrade } from '../components/plans/UpgradeProvider';

export function useGuardedAction(limitKey) {
  const { remaining, limit, current } = useLimit(limitKey);
  const upgrade = useUpgrade();

  return useCallback((action) => {
    if (remaining <= 0) {
      upgrade?.openUpgrade({
        error: 'limit_reached',
        limitKey,
        limit,
        current,
        message: 'Você atingiu o limite do seu plano. Faça upgrade para continuar.',
      });
      return;
    }
    if (typeof action === 'function') action();
  }, [remaining, limit, current, limitKey, upgrade]);
}

export default useGuardedAction;
